module.exports = __webpack_public_path__ + "static/flags/CM-e4a1be0c65d016774fa3dd668f3db6bd.gif";